import React, { useState, useEffect } from 'react'
import TabsTemplate from '../../../../templates/components/TabsTemplate'
import PaymentOptionTableSettings from './payment-option-table-settings/PaymentOptionTableSettings'

const PaymentSettings = (props) => {
    return (
        <TabsTemplate id="paymentSettings" accordionId="paymentSettings">
            <div title='Payment Options'>
                <PaymentOptionTableSettings/>
            </div>
        </TabsTemplate>
    )
}
export default PaymentSettings